module.exports = __webpack_public_path__ + "img/3.80258253.png";